import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { StorageService } from 'core-tsi';
import { AuthService } from '../auth/data-access/auth.service';

export const accesoAppGuard: CanActivateFn = (route, state) => {

  const router = inject(Router)
  const authService = inject(AuthService)
  const session = StorageService.getSession()

  if (!(session && session.token)) {
    router.navigate(['/login'])
    return false
  }

  return authService.validateToken().pipe(
    map(() => true),
    catchError(() => {
      StorageService.clearStorage()
      router.navigate(['/login'])
      return of(false)
    })
  )
}
